module.exports = __webpack_public_path__ + "static/Creator 16 - @FastAnne-8676e3c0d5acfb6879f5e5b1e77c795c.png";